module.exports = __webpack_public_path__ + "static/media/yellowtriangle.6a503c6b.svg";